import Component from '@glimmer/component';
export interface FormationPartsFormatorComponentArgs {}
import config from 'frontend/config/environment';

export default class FormationPartsFormatorComponent extends Component<FormationPartsFormatorComponentArgs> {
  config = config;
}
